import { gql, MutationResult, useMutation } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const setCepStatusToFeedbackMutationCall = gql`
  mutation setCepStatusToFeedback($id: String!, $sendToVeeva: Boolean!) {
      setCepStatusToFeedback(id: $id, sendToVeeva: $sendToVeeva)
  }
`;

type ResultType = {
  setCepStatusToFeedback: boolean;
};

type UseSetCepStatusToFeedbackMutation = [
  (id: string) => Promise<boolean>,
  MutationResult<ResultType>,
];

export const useSetCepStatusToFeedbackMutation = (): UseSetCepStatusToFeedbackMutation => {
  const [setCepStatusToFeedback, state] = useMutation<ResultType>(setCepStatusToFeedbackMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });
  const flags = useFlags();

  const executeMutation = useCallback(async (id) => {
    try {
      const { data } = await setCepStatusToFeedback({
        variables: {
          id,
          sendToVeeva: flags.mayaEnableVeevaBiogenlinc1816,
        },
      });
      return data?.setCepStatusToFeedback || false;
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'setCepStatusToFeedback.ts - useSetCepStatusToFeedbackMutation',
        });
      }
      return false;
    }
  }, [setCepStatusToFeedback, flags.mayaEnableVeevaBiogenlinc1816]);

  return [executeMutation, state];
};
